import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import HeaderContent from './components/HeaderContent';
import ListContainer from './components/ListContainer';
import HeaderEventData from './components/HeaderEventData';
import ListContainerWap from './wapComponents/ListContainerWap';
import EventCardProfile from '../../../../components/EventTemplate/EventCardProfile';
import OtherStores from './wapComponents/OtherStores';
import InputButton from './../../../../components/ZUILib/InputButton';
import ApplyCSS from './../../../../components/ApplyCSS';
import Warning2 from '../../../../components/Warning2';
import AppEvents from '../../../App/AppEvents';
import Pagination from '../../../../components/Pagination';
import * as labelsActions from '../../../../components/labels/actions';

import commonUtil from '../../../../utils/commonUtil';
import * as defaultConst from '../../../../utils/clientConstant';
import * as giftListGuestViewAction from './actions';
import NotAvailableGifthTable from './wapComponents/NotAvailableGifthTable';
import IndicatorTotalProducts from './wapComponents/IndicatorTotalProducts';
import * as landingPageActions from "../../../BrowseAndNavigate/MesaHomePage/actions";
import { goToTopIconWap } from '../../../../components/NewHeader/Header/svgIcons';
import serverClientUtil from './../../../../utils/serverClientUtil';

import * as giftListActions from '../GiftList/actions';
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

const { isLablesLoaded, loadLables } = labelsActions;
const { getGiftListGuestView, setGifteeName } = giftListGuestViewAction;
const { isContentLoaded, loadContent } = landingPageActions;
const pageName = 'giftListGuestView';

const GIFTS_PER_PAGE = channel === constChannels.WAP ? '30' : '52';

import * as EventCategoryActions from "../../../../components/eventcategory/actions";
import Accordion from '../GiftList/components/Accordion';
import MarketingContentSection from '../../../BrowseAndNavigate/MarketingContentSection';
import VozCliente from '../../../../components/VozCliente';
import { browserHistory } from 'react-router';

const applicationRoutes = commonUtil.getApplicationRoutes();
const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;
const FEATURE_FLAGS = {
  newGiftListUI: true,  // toggle this to enable/disable new UI
};
const { getReceivedGiftList, getRegisteredGiftList, getPersonalShoppingList, getEventSummaryInfo, setNotificationCount, getEventDetails, getEventThresholdGiftDetails, getGiftlistMarketingContent, getGiftlistFooterMarketingContent } = giftListActions;

const cms_page_id = 'giftlist-guest-view';
@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
 {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isContentLoaded(getState(), cms_page_id)) {
        return dispatch(loadContent(cms_page_id));
      }
      return undefined;
    },
  },
{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isEventCategoryLoaded(getState())) {
      return dispatch(loadEventCategoryEvent());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  user: store.user.data,
  extraData: store.labels.extraData,
  eventCategory: store.eventcategory.data,
  content : store.giftList.data,
  multisiteData:store.getMarketingLandingPage.data,
}),
  {
    ...labelsActions,getGiftlistMarketingContent,...landingPageActions,
  })

class GiftListGuestView extends Component {
  constructor(props) {
    super(props);
    this.itemsCount = '';
    this.currentPage = '1';
    this.recordsPerPage = '';
    this.wapBackButtonEvent = null;
    this.paginationClicked = false;
    this.arrayDataProductsData = [];
    this.changeComponentOnBackButtonClick = this.changeComponentOnBackButtonClick.bind(this);
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    this.state = {
      gifthList: [],
      loadMoreForPrice: '',
      loadMoreForCategory: '',
      activeCategory : 'Todas las categorías',
      priceFilter : 'Ascending',
      showScrollIcon:false,
      alertType: 'success',
    };
  }

  componentWillMount() {
    this.props.getGiftListGuestView(this.eventId, 'Ascending', '', '1', 'false', GIFTS_PER_PAGE);
  }

  componentDidMount() {
    this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [this.changeComponentOnBackButtonClick]);
    }
    
    // console.log("getSearchFooterMarketingContent called");
    // // this.props.getGiftlistMarketingContent("search-footer-markerting-section");
    commonUtil.addTransition();
    const dataLayer = {
      event: 'view_item_list',
      seccion: 'Mesa de regalos',
      phase: 'Mesa de regalos',
      phase_detail: 'Lista',
      list: `${this.eventId} | Lista mesa`,
      specific_generator: 'Y',
      generator_type: 'Lista Mesa',
      generator_value: `${this.eventId}`,
      gift_list_type: `${this.eventId} | Lista mesa`,
      item_list_name: 'Lista de festejado',
    };
    window.dataLayer.push(dataLayer);
    window.addEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const isWap = commonUtil.getChannel() === "wap"
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (isWap && scrollTop > 1000) {
      this.setState({ showScrollIcon: true });
    } else {
      this.setState({ showScrollIcon: false });
    }
  };
  
  componentWillUnmount(){
    window.removeEventListener("scroll", this.handleScroll);
  }
  componentWillReceiveProps(nextProps) {
    this.guestViewGiftList = nextProps;
    this.tempProductData = nextProps && nextProps.guestViewGiftList ? nextProps.guestViewGiftList : null;
    if (Array.isArray(this.tempProductData.itemsInfo)) {
      this.setState(prevState => ({
        gifthList: nextProps.guestViewGiftList.currentPage === '1'
          ? [...this.tempProductData.itemsInfo]
          : [...prevState.gifthList, ...this.tempProductData.itemsInfo],
      }));
    }
  }

  displayAlertMessage = (message, type) => {
    this.setState({ alertType: type});
    this.warning2.setMessage(message);
  }

  setCopyToClipboard = async () => {
    const currentUrl = document.URL;
    try {
      await navigator.clipboard.writeText(`${currentUrl}`);
    } finally {
      this.warning.setMessage('¡Listo! El enlace a la lista de regalos se ha copiado con éxito.');
    }
    this.goToTop();
  }

  changeComponentOnBackButtonClick = () => {
    window.history.back();
  }

  compareEventStatus = (eventStatus, possibleStatus) => {
    if (!eventStatus && eventStatus !== '' && eventStatus !== 'undefined') {
      return false;
    }
    if (Array.isArray(possibleStatus)) {
      return possibleStatus.filter(status => status.toUpperCase() === eventStatus.toUpperCase()).length;
    }
    return possibleStatus.toUpperCase() === eventStatus.toUpperCase();
  }

  clearFilter = () => {
    this.headerContentWebRef.clearAllFilter();
  }

  onPageChange = (val) => {
    this.paginationClicked = true;
    this.headerContentWebRef && this.headerContentWebRef.onPageChange(val);
  }

  getDisplayStyle = (brand) => {
    if (brand === commonUtil.getBrand()) {
      return 'hide';
    }
    return '';
  }

  filterAndSorting = (option,categoryId) => {
    // this.categoryID = this.categoryTypeFilter.getID();
    this.price = option?.id || this.sortProductByPrice.getID();

    this.props.getGiftListGuestView(this.eventId, (this.price || ''), (categoryId || this.state.activeCategory || ''), '1', 'false', GIFTS_PER_PAGE);
  }

  redirectToHome = () => {
        
   this.redirectButtonName  = commonUtil.getLabel(this.props?.lables?.GuestviewPage, `guestview.redirecturl.${serverClientUtil.getBrand()}`);
    window.location.href = this.redirectButtonName;
  }

  renderWeb() {
     const lables = this.props.lables;
       let eventData = _.find(this.props?.eventCategory?.eventConfigurations,['name',this.props?.guestViewGiftList?.eventInfo?.eventType])
       let themeData = _.find(eventData?.event_themes,["uid",this.props?.guestViewGiftList?.eventInfo?.eventTheme]) || eventData?.event_themes[0];
       let eventIcon =  eventData?.event_icon;
     const paginationInfo = {
      totalNoOfRecords: this.itemsCount,
      recordsPerPage: this.recordsPerPage,
      currentPage: this.currentPage,
      totalPages : this.props.guestViewGiftList.totalPages
    };
      // this.setState({selectedTheme : themeData, eventIcon: eventIcon })
     
    if(true) {

      return (
      <React.Fragment>
        <div className="container-wrap p-t-20">
          <div className="container">
              <div className='alertSearchWarning' style={{ display: 'flex', flexDirection: 'column' }}>
              <Warning2
                type="success"
                onClose
                notSetToTop
                style={{ backgroundColor: '#E7F8EC', position: "absolute", top: '-20px'  }}
                text={this.errorMessage}
                ref={warning => this.warning = warning}
              />
              <Warning2
                type={this.state.alertType}
                onClose
                notSetToTop
                text={this.errorMessage}
                style={{ position: "absolute", top: '-20px'  }}
                ref={warning2 => this.warning2 = warning2}
              />
            </div>
            <div className="mainContent mainContentDimensions">
              {this.guestViewGiftList ?
                <React.Fragment>
                  <EventCardProfile 
                      selectedTheme={themeData || {}}
                      icon={eventIcon}
                      // handleSuspendedEventUpdate={this.handleSuspendedEventUpdate}
                      eventId={this.props?.guestViewGiftList?.eventInfo?.eventId}
                      // hideModal={() => this.brandModal.hideModal}
                      lables={lables}
                      // compareEventStatus={this.compareEventStatus}
                      // summaryInfoResponse={this.summaryInfoResponse}
                      // icon={this.state.eventIcon}
                      eventInfo = {this.props?.guestViewGiftList?.eventInfo || {}}
                      ownerName={this.props?.guestViewGiftList?.eventInfo?.user1firstName || ""} 
                      coOwnerName={this.props?.guestViewGiftList?.eventInfo?.user2firstName || ""} 
                      CelebrityName={""} 
                      message={this.props?.guestViewGiftList?.eventInfo?.comment || ""} 
                      eventDateValue={this.props?.guestViewGiftList?.eventInfo?.eventDate || ""} 
                      eventTxtValue={this.props?.guestViewGiftList?.eventInfo?.eventName || ""}
                      userInfo={this.props?.guestViewGiftList?.userInfo || {}}
                      isGuestViewListPage={true}                     />
                    <p class="lisa-regalos" style={{background:`${themeData?.color_100}` , color:`${themeData?.color_500}`}}>Lista de regalos</p>
                  <HeaderContent
                    currentPageDownPagination={this.currentPage}
                    ref={headerContentWebRef => this.headerContentWebRef = headerContentWebRef}
                    categoryItemsInfo={this.props.guestViewGiftList.categoryItemsInfo}
                    eventId={this.eventId}
                    guestViewGiftListData={this.guestViewGiftList}
                    getGiftListGuestView={this.props.getGiftListGuestView}
                    onSetGifteeName={this.props.setGifteeName}
                    labels={this.props.lables}
                    eventName={this.props.eventName}
                    eventDate={this.props.eventDate}
                    eventType={this.props.eventType}
                    printingDate={this.props.printingDate}
                    itemsCount={this.itemsCount}
                    setCopyToClipboard={this.setCopyToClipboard}
                    categoryId = {this.state.activeCategory != "Todas las categorías" ? this.state.activeCategory : '' }
                    handlePriceFilterChange = {this.handlePriceFilterChange}
                    priceFilter={this.state.priceFilter}
                    selectedTheme={themeData || {}}
                  />
                </React.Fragment>
                : null}
            </div>
          </div>
           <div className="container">
            {this.tempProductData && this.tempProductData.itemsCount != 0 ? (
            <div className='grid_container_gift_list'>
              {
                this.guestViewGiftList && this.tempProductData && this.tempProductData.categoryItemsInfo && this.tempProductData.categoryItemsInfo.length ?
                  <ListContainer
                    guestViewGiftListData={this.tempProductData}
                    eventId={this.eventId}
                    gifteeId={this.props.gifteeName}
                    getGiftListGuestView={this.props.getGiftListGuestView}
                    labels={this.props.lables}
                    compareEventStatus={this.compareEventStatus}
                    clearFilter={this.clearFilter}
                    displayAlertMessage={this.displayAlertMessage}
                  /> : <h4>{commonUtil.getLabel(lables.GuestviewPage, 'guestview.your.search.displayed.zero.results')}</h4>
              }
            </div>
            ) : (
              <div className="guestView-no-products">
                <button className="empty-guestView-btn" style={{background:`${themeData?.color_500}`}} onClick={() =>this.redirectToHome()}>
                  Ir a Liverpool
                </button>
              </div>
            )
            }
            <div className="col-md-3 col-sm-3 numberProducts" style={{ width:'934px'}}>
              {/* Pagination */}
              {+this.props.guestViewGiftList.itemsCount > +this.props.guestViewGiftList.recordsPerPage ?
              (
                <div className="paginationContainer event_search_pagination" style={{ margin: '30px 0 30px 0', justifyContent: 'flex-end' }}>
                  <Pagination paginationInfo={paginationInfo} onPageChange={this.onPageChange} />
                </div>
              )
              : null
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    );
    }

    if (!this.guestViewGiftList && !this.tempProductData) {
      return null;
    }

    // const paginationInfo = {
    //   totalNoOfRecords: this.itemsCount,
    //   recordsPerPage: this.recordsPerPage,
    //   currentPage: this.currentPage,
    // };
    // const lables = this.props.lables;
    return (
      <React.Fragment>
        <div className="container-wrap p-t-20">
          <div className="container">
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
              <Warning2
                type="success"
                onClose
                notSetToTop
                style={{ backgroundColor: '#E7F8EC' }}
                text={this.errorMessage}
                ref={warning => this.warning = warning}
              />
            </div>
            <div className="mainContent">
              {this.guestViewGiftList ?
                <React.Fragment>
                  <HeaderEventData
                    eventId={this.eventId}
                    typeOrder={this.typeOrder}
                    giftsPerPage={GIFTS_PER_PAGE}
                    getDisplayStyle={this.getDisplayStyle}
                    setCopyToClipboard={this.setCopyToClipboard}
                    getCategoryForHeader={this.getCategoryHeader}
                    guestViewGiftListData={this.guestViewGiftList.guestViewGiftList}
                    ref={headerContentRef => this.headerContentRef = headerContentRef}
                    {...this.props}
                  />
                  <HeaderContent
                    currentPageDownPagination={this.currentPage}
                    ref={headerContentWebRef => this.headerContentWebRef = headerContentWebRef}
                    categoryItemsInfo={this.props.guestViewGiftList.categoryItemsInfo}
                    eventId={this.eventId}
                    guestViewGiftListData={this.guestViewGiftList}
                    getGiftListGuestView={this.props.getGiftListGuestView}
                    onSetGifteeName={this.props.setGifteeName}
                    labels={this.props.lables}
                    eventName={this.props.eventName}
                    eventDate={this.props.eventDate}
                    eventType={this.props.eventType}
                    printingDate={this.props.printingDate}
                    itemsCount={this.itemsCount}
                    setCopyToClipboard={this.setCopyToClipboard}
                  />
                </React.Fragment>
                : null}
            </div>
          </div>
          <div className="container">
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
              {
                this.guestViewGiftList && this.tempProductData && this.tempProductData.categoryItemsInfo && this.tempProductData.categoryItemsInfo.length ?
                  <ListContainer
                    guestViewGiftListData={this.tempProductData}
                    eventId={this.eventId}
                    gifteeId={this.props.gifteeName}
                    getGiftListGuestView={this.props.getGiftListGuestView}
                    labels={this.props.lables}
                    compareEventStatus={this.compareEventStatus}
                    clearFilter={this.clearFilter}
                  /> : <h4>{commonUtil.getLabel(lables.GuestviewPage, 'guestview.your.search.displayed.zero.results')}</h4>
              }
            </div>
            <div className="col-md-3 col-sm-3 numberProducts">
              {/* Pagination */}
              {+this.props.guestViewGiftList.itemsCount > +this.props.guestViewGiftList.recordsPerPage ?
              (
                <div className="paginationContainer" style={{ margin: '30px 0 30px 0', justifyContent: 'flex-start' }}>
                  <Pagination paginationInfo={paginationInfo} onPageChange={this.onPageChange} />
                </div>
              )
              : null
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  goToTop = (element) => {
    if (typeof element === 'number') {
      document.querySelector(`.product_${element.toString()}`).scrollIntoView({ behavior: 'smooth' });
      return;
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  goToNextPage = () => {
    const nextPage = +this.currentPage + 1;
    const orderFilterType = this.state.priceFilter || 'Ascending';
    const categoryHeaderHttp = this.state.loadMoreForCategory || '';
    this.props.getGiftListGuestView(
      this.eventId,
      orderFilterType,
      categoryHeaderHttp,
      nextPage.toString(),
      'false',
      GIFTS_PER_PAGE,
    );
    this.setState(prevState => ({
      gifthList: [...prevState.gifthList],
    }));
  };

  typeOrder = (order) => {
    this.setState({ ...this.state, loadMoreForPrice: order, loadMoreForCategory: '' });
  }

  getCategoryHeader = (categoryId) => {
    this.setState({ ...this.state, loadMoreForCategory: categoryId });
  }

  clearSelectedFilter = () => {
    this.headerContentRef?.clearSelectedValue?.();
  }

  handleCategoryChange = (selectedData) => {
    if (selectedData != "Todas las categorías"){
      if (selectedData == this.state.activeCategory) {
          this.props.getGiftListGuestView(this.eventId, (this.state.priceFilter || ''), (''), '1', 'false', GIFTS_PER_PAGE);
          this.setState({ activeCategory: "Todas las categorías" });
        }
        else {
          this.props.getGiftListGuestView(this.eventId, (this.state.priceFilter || ''), (selectedData || this.state.activeCategory || ''), '1', 'false', GIFTS_PER_PAGE);
          this.setState({ activeCategory: selectedData });
        }
    }
    else {
       this.props.getGiftListGuestView(this.eventId, (this.state.priceFilter || ''), (''), '1', 'false', GIFTS_PER_PAGE);
       this.setState({ activeCategory: "Todas las categorías" });
    }
     
  };

  handlePriceFilterChange = (selectedData) => {
      this.props.getGiftListGuestView(this.eventId, (selectedData || this.state.priceFilter || ''), (this.state.activeCategory != "Todas las categorías" ? this.state.activeCategory : ''  || ''), '1', 'false', GIFTS_PER_PAGE);
      this.setState({ priceFilter: selectedData });
  };

  renderWap() {
    const { guestViewGiftList } = this.props;
    const lables = this.props.lables;
       let eventData = _.find(this.props?.eventCategory?.eventConfigurations,['name',this.props?.guestViewGiftList?.eventInfo?.eventType])
       let themeData = _.find(eventData?.event_themes,["uid",this.props?.guestViewGiftList?.eventInfo?.eventTheme]) || eventData?.event_themes[0];
       let eventIcon =  eventData?.event_icon ;
    const NextButton = {
      id: 'nextButton',
      type: 'button',
      value: 'Cargar más productos',
      autoFocus: false,
      style: 'btnSecondarySpecial size-Full',
      iconClass: '',
      onClickHandler: this.goToNextPage,
      cssStyle: {
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none',
        borderRadius: '4px',
        height: '48px',
        fontFamily: 'robotoRegular',
        color: '#1C1C1C',
        fontSize : '14px',
        textDecorationLine : 'underline',
        textAlign:' center',
      },
    };

    const GoToTop = {
      id: 'goToTopOfList',
      type: 'button',
      value: 'Volver arriba',
      autoFocus: false,
      style: 'size-Full',
      iconClass: '',
      onClickHandler: this.goToTop,
      cssStyle: {
        height: '48px',
        fontFamily: 'robotoRegular',
        color: '#e10098',
        textDecoration: 'underline',
        border: 'none',
        background: 'transparent',
      },
    };

    if (!this.guestViewGiftList && !this.tempProductData) {
      return null;
    }

    return (
      <div className={'row wrap'}>

        {this.guestViewGiftList ?
          <React.Fragment>
            <Warning2
              onClose
              type="success"
              notSetToTop
              ref={warning => this.warning = warning}
              style={{position: 'absolute', padding: '8px 12px', backgroundColor: '#E7F8EC' , zIndex:'999', top:"-4px", width:"86.978%", height:"32px", boxSizing:"content-box", marginInline:"16px"}}
              spanStyle={{height:'auto', fontSize:'12px' , fontWeight:"600"}}
            />
            <Warning2
              type={this.state.alertType}
              onClose
              notSetToTop
              text={this.errorMessage}
              ref={warning2 => this.warning2 = warning2}
              style={{position: 'absolute', padding: '8px 12px', zIndex:'999', top:"-4px", width:"86.978%", height:"32px", boxSizing:"content-box", marginInline:"16px"}}
              spanStyle={{height:'auto', fontSize:'12px' , fontWeight:"600"}}
            />
             <EventCardProfile 
                      selectedTheme={themeData || {}}
                      icon={eventIcon}
                      // handleSuspendedEventUpdate={this.handleSuspendedEventUpdate}
                      eventId={this.props?.guestViewGiftList?.eventInfo?.eventId}
                      // hideModal={() => this.brandModal.hideModal}
                      lables={lables}
                      // compareEventStatus={this.compareEventStatus}
                      // summaryInfoResponse={this.summaryInfoResponse}
                      // icon={this.state.eventIcon}
                      eventInfo = {this.props?.guestViewGiftList?.eventInfo || {}}
                      ownerName={this.props?.guestViewGiftList?.eventInfo?.user1firstName || ""} 
                      coOwnerName={this.props?.guestViewGiftList?.eventInfo?.user2firstName || ""} 
                      CelebrityName={""} 
                      message={this.props?.guestViewGiftList?.eventInfo?.comment || ""} 
                      eventDateValue={this.props?.guestViewGiftList?.eventInfo?.eventDate || ""} 
                      eventTxtValue={this.props?.guestViewGiftList?.eventInfo?.eventName || ""}
                      userInfo={this.props?.guestViewGiftList?.userInfo || {}}
                      isGuestViewListPage={true} 
                    />
                    <p class="lisa-regalos" style={{background:`${themeData?.color_100}` , color:`${themeData?.color_500}`}}>Lista de regalos</p>
            {/* <HeaderEventData
              eventId={this.eventId}
              typeOrder={this.typeOrder}
              giftsPerPage={GIFTS_PER_PAGE}
              setCopyToClipboard={this.setCopyToClipboard}
              getCategoryForHeader={this.getCategoryHeader}
              guestViewGiftListData={this.guestViewGiftList.guestViewGiftList}
              ref={headerContentRef => this.headerContentRef = headerContentRef}
              {...this.props}
            /> */}
              <HeaderContent
                    currentPageDownPagination={this.props.guestViewGiftList.currentPage}
                    ref={headerContentWebRef => this.headerContentWebRef = headerContentWebRef}
                    categoryItemsInfo={this.props.guestViewGiftList.categoryItemsInfo}
                    eventId={this.eventId}
                    guestViewGiftListData={this.guestViewGiftList}
                    getGiftListGuestView={this.props.getGiftListGuestView}
                    onSetGifteeName={this.props.setGifteeName}
                    labels={this.props.lables}
                    eventName={this.props.eventName}
                    eventDate={this.props.eventDate}
                    eventType={this.props.eventType}
                    printingDate={this.props.printingDate}
                    itemsCount={this.itemsCount}
                    setCopyToClipboard={this.setCopyToClipboard}
                     handlePriceFilterChange = {this.handlePriceFilterChange}
                    priceFilter={this.state.priceFilter}
                    categoryId = {this.state.activeCategory != "Todas las categorías" ? this.state.activeCategory : '' }
                    handleCategoryChange= {this.handleCategoryChange}
                    selectedTheme={themeData || {}}
                  />
            {/* <div style={{ display: 'flex', justifyContent: 'right', clear: 'both', paddingRight: 20 }}>
              <IndicatorTotalProducts
                recordsPerPage={guestViewGiftList.recordsPerPage}
                currentPage={guestViewGiftList.currentPage}
                itemsCount={guestViewGiftList.itemsCount}
                totalRecords={guestViewGiftList.totalRecordsShowed}
                labelTitle={'productos'}
              />
            </div> */}
          </React.Fragment>
          : null}
        {this.tempProductData && this.tempProductData.itemsCount != 0 ?
          (this.guestViewGiftList && this?.tempProductData && this?.tempProductData?.categoryItemsInfo?.length ?
          <ListContainerWap
            eventId={this.eventId}
            labels={this.props.lables}
            gifteeId={this.props.gifteeName}
            guestViewGiftListData={this.tempProductData}
            clearSelectedFilter={this.clearSelectedFilter}
            getGiftListGuestView={this.props.getGiftListGuestView}
            gifthList={this.state.gifthList}
            giftsPerPage={GIFTS_PER_PAGE}
            displayAlertMessage={this.displayAlertMessage}
            goToTop={this.goToTop}
          /> : <h4>{commonUtil.getLabel(lables.GuestviewPage, 'guestview.your.search.displayed.zero.results')}</h4>) : (
            <div className="guestView-no-products">
                <button className="empty-guestView-btn" style={{background:`${themeData?.color_500}`}} onClick={() =>this.redirectToHome()}>
                  Ir a Liverpool
                </button>
              </div>
          )}

          {this.state.showScrollIcon && <div className='go-top-button' style={{background:`${themeData?.color_500}`}} onClick={this.goToTop}>
             {/* <img src={commonUtil.getAssetURL() + "/images/arrow_upward.svg"} />
              */}
              {goToTopIconWap}
          </div>}
        <div className="col-xs-12 footerNav" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {guestViewGiftList &&
          (+guestViewGiftList.currentPage) != (+guestViewGiftList.totalPages) ?
            <div>
              <InputButton buttonAttr={NextButton} />
            </div>
          : null}

          {/* <IndicatorTotalProducts
            recordsPerPage={guestViewGiftList.recordsPerPage}
            currentPage={guestViewGiftList.currentPage}
            itemsCount={guestViewGiftList.itemsCount}
            totalRecords={guestViewGiftList.totalRecordsShowed}
            labelTitle={'resultados'}
          /> */}
  
              {/* <div>
                <InputButton buttonAttr={GoToTop} />
              </div> */}

          {/* <OtherStores labels={lables} eventId={this.eventId} /> */}
        </div>
          <div className="col-xs-12 wap-guest-view">
            <MarketingContentSection contentSection={this.props?.multisiteData} store={this.props.store} />
          </div>
      </div>
    );
  }

  render() {
    const { guestViewGiftList } = this.props;
    const lables = this.props.lables;
    this.currentPage = guestViewGiftList && guestViewGiftList.currentPage;
    this.recordsPerPage = guestViewGiftList && guestViewGiftList.recordsPerPage;
    this.itemsCount = guestViewGiftList && guestViewGiftList.itemsCount;
    const eventStatus = guestViewGiftList && guestViewGiftList.eventInfo && guestViewGiftList.eventInfo.eventStatus
    ? guestViewGiftList.eventInfo.eventStatus
    : '';
    const categories = [{ id: "Todas las categorías", name: "Todas las categorías" },...(guestViewGiftList.categoryList || [])
];

    if (guestViewGiftList && eventStatus) {
       const accordianFilterData = [

      {
          title: 'Filtrar', 
          content: (
            <>
            <div>Categorías</div>
            <ul className="filter-steps">
              {categories?.map((ele, idx) => (
                <li 
                  key={idx}
                  className={`filter-step ${this.state.activeCategory === ele.id ? 'active' : ''}`}
                  onClick={() => this.handleCategoryChange(ele.id)}
                >
                  {this.state.activeCategory === ele.id && <div className="dot-line"></div>}
                  {ele.name}
                </li>
              ))}
            </ul>
            </>
          ),
          showOnLoad: true,
          }
    ]
      return (
        <React.Fragment>
          <ApplyCSS pageName={pageName} />
          {this.compareEventStatus(eventStatus, defaultConst.constEventStatus.NEW_ACTIVE) || this.compareEventStatus(eventStatus, defaultConst.constEventStatus.ACTIVE) || this.compareEventStatus(eventStatus, defaultConst.constEventStatus.ADMINPROCESS) || this.compareEventStatus(eventStatus, defaultConst.constEventStatus.UNDER_REVIEW) ?
            <React.Fragment>
              {channel == constChannels.WAP && <VozCliente/>}
              {
                channel == constChannels.WAP ? this.renderWap() :  <>
                <div className='row gift-list-container'>
                    <aside className="col-md-3 gift-list-sidebar-container" style={{marginTop:'40px'}}>
                        { this.tempProductData && this.tempProductData.itemsCount != 0 &&
                              <div className="gift-list-sidebar-guestview">
                              <div className="category-filter">
                                  <div className="mode_address_change">
                                    <Accordion items={accordianFilterData} alwaysOpen={0} />
                                  </div>
                              </div>
                              </div>
                        }
                          </aside>
                          <div className='col-md-9 gift-list-info'>
                              <div className='giftList-main-section-search'>
                                {this.renderWeb()}
                              </div>
                          </div>
                <div className="row">
                 {/* <div className='banner-main-text' style={{marginTop:"64px"}}>
                      Más tiendas, más regalos, más felicidad.
                    </div>
                    <div className='banner-container'>
                        <p className='banner-container-text'>Consulta este evento en otras boutiques y encuentra regalos exclusivos</p>
                    </div> */}
                 <div className="col-xs-12 guest-view-marketing-section" id='marketingContentSection_giftlist'>
                   <MarketingContentSection contentSection={this.props?.multisiteData} store={this.props.store} />
                 </div>
              </div>
                </div>
              </>
              }
             
            </React.Fragment>
            : <NotAvailableGifthTable labels={lables} />}
        </React.Fragment>
      );
    }
    else if(FEATURE_FLAGS.newGiftListUI) {
       return (
        <React.Fragment>
          <ApplyCSS pageName={pageName} />
            <React.Fragment>
              {channel === constChannels.WAP ? this.renderWap() : this.renderWeb()}
            </React.Fragment>
        </React.Fragment>
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  lables: state.labels.data,
  guestViewGiftList: state.giftListGuestViewList.data,
  gifteeName: state.giftListGuestViewList.gifteeName,
  eventName: state.giftListGuestViewList.data && state.giftListGuestViewList.data.eventInfo && state.giftListGuestViewList.data.eventInfo.eventName,
  eventDate: state.giftListGuestViewList.data && state.giftListGuestViewList.data.eventInfo && state.giftListGuestViewList.data.eventInfo.eventDate,
  eventType: state.giftListGuestViewList.data && state.giftListGuestViewList.data.eventInfo && state.giftListGuestViewList.data.eventInfo.eventType,
  printingDate: state.info && state.info.data && state.info.data.time,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getGiftListGuestView, setGifteeName }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(GiftListGuestView);
